export const createData = () => {
  return [
    {
      title: "a games",
      cards: [
        {
          date: "Sat, Apr 4",
          time: "6:05 pm",
          logo: "reds.svg",
        },
        {
          date: "Mon, Apr 27",
          time: "7:05 pm",
          logo: "yankees.svg",
        },
        {
          date: "Tue, Apr 28",
          time: "7:05 pm",
          logo: "yankees.svg",
        },
        {
          date: "Wed, Apr 29",
          time: "1:35 pm",
          logo: "yankees.svg",
        },
        {
          date: "Fri, May 8",
          time: "7:05 pm",
          logo: "cubs.svg",
        },
        {
          date: "Sat, May 9",
          time: "6:05 pm",
          logo: "cubs.svg",
        },
        {
          date: "Sun, May 10",
          time: "1:35 pm",
          logo: "cubs.svg",
        },
        {
          date: "Mon, May 25",
          time: "6:05 pm",
          logo: "astros.svg",
        },
        {
          date: "Thu, May 28",
          time: "7:05 pm",
          logo: "astros.svg",
        },
        {
          date: "Sat, May 30",
          time: "3:05 pm",
          logo: "royals.svg",
        },
        {
          date: "Sat, Jun 6",
          time: "6:35 pm",
          logo: "guardians.svg",
        },
        {
          date: "Fri, Jun 19",
          time: "7:05 pm",
          logo: "padres.svg",
        },
        {
          date: "Sat, Jun 20",
          time: "3:05 pm",
          logo: "padres.svg",
        },
        {
          date: "Sun, Jun 21",
          time: "1:35 pm",
          logo: "padres.svg",
        },
        {
          date: "Sat, Jul 4",
          time: "3:05 pm",
          logo: "tigers.svg",
        },
        {
          date: "Fri, Jul 10",
          time: "7:05 pm",
          logo: "astros.svg",
        },
        {
          date: "Sat, Jul 11",
          time: "6:05 pm",
          logo: "astros.svg",
        },
        {
          date: "Sun, Jul 12",
          time: "1:35 pm",
          logo: "astros.svg",
        },
        {
          date: "Fri, Jul 24",
          time: "7:05 pm",
          logo: "mariners.svg",
        },
        {
          date: "Sat, Jul 25",
          time: "6:15 pm",
          logo: "mariners.svg",
        },
        {
          date: "Sun, Jul 26",
          time: "1:35 pm",
          logo: "mariners.svg",
        },
        {
          date: "Thu, Sep 17",
          time: "7:05 pm",
          logo: "red-sox.svg",
        },
        {
          date: "Sat, Sep 19",
          time: "6:05 pm",
          logo: "blue-jays.svg",
        },
      ],
    },
    {
      title: "b games",
      cards: [
        {
          date: "Sun, Apr 5",
          time: "1:35 pm",
          logo: "reds.svg",
        },
        {
          date: "Fri, Apr 24",
          time: "7:05 pm",
          logo: "athletics.svg",
        },
        {
          date: "Sat, Apr 25",
          time: "6:05 pm",
          logo: "athletics.svg",
        },
        {
          date: "Sun, Apr 26",
          time: "1:35 pm",
          logo: "athletics.svg",
        },
        {
          date: "Tue, May 26",
          time: "7:05 pm",
          logo: "astros.svg",
        },
        {
          date: "Wed, May 27",
          time: "7:05 pm",
          logo: "astros.svg",
        },
        {
          date: "Fri, May 29",
          time: "7:05 pm",
          logo: "royals.svg",
        },
        {
          date: "Sun, May 31",
          time: "1:35 pm",
          logo: "royals.svg",
        },
        {
          date: "Fri, Jun 5",
          time: "7:05 pm",
          logo: "guardians.svg",
        },
        {
          date: "Sun, Jun 7",
          time: "1:35 pm",
          logo: "guardians.svg",
        },
        {
          date: "Thu, Jun 18",
          time: "1:35 pm",
          logo: "twins.svg",
        },
        {
          date: "Thu, Jul 2",
          time: "7:05 pm",
          logo: "tigers.svg",
        },
        {
          date: "Sun, Jul 5",
          time: "2:30 pm",
          logo: "tigers.svg",
        },
        {
          date: "Mon, Aug 3",
          time: "7:05 pm",
          logo: "giants.svg",
        },
        {
          date: "Tue, Aug 4",
          time: "7:05 pm",
          logo: "giants.svg",
        },
        {
          date: "Wed, Aug 5",
          time: "1:35 pm",
          logo: "giants.svg",
        },
        {
          date: "Fri, Aug 7",
          time: "7:05 pm",
          logo: "orioles.svg",
        },
        {
          date: "Sat, Aug 8",
          time: "6:15 pm",
          logo: "orioles.svg",
        },
        {
          date: "Sun, Aug 9",
          time: "1:35 pm",
          logo: "orioles.svg",
        },
        {
          date: "Fri, Aug 21",
          time: "7:05 pm",
          logo: "angels.svg",
        },
        {
          date: "Sat, Aug 22",
          time: "6:05 pm",
          logo: "angels.svg",
        },
        {
          date: "Sun, Aug 23",
          time: "1:35 pm",
          logo: "angels.svg",
        },
        {
          date: "Fri, Sep 4",
          time: "7:05 pm",
          logo: "rays.svg",
        },
        {
          date: "Sat, Sep 5",
          time: "6:05 pm",
          logo: "rays.svg",
        },
        {
          date: "Sun, Sep 6",
          time: "1:35 pm",
          logo: "rays.svg",
        },
        {
          date: "Tue, Sep 15",
          time: "7:05 pm",
          logo: "red-sox.svg",
        },
        {
          date: "Wed, Sep 16",
          time: "7:05 pm",
          logo: "red-sox.svg",
        },
        {
          date: "Fri, Sep 18",
          time: "7:05 pm",
          logo: "blue-jays.svg",
        },
        {
          date: "Sun, Sep 20",
          time: "1:35 pm",
          logo: "blue-jays.svg",
        },
        {
          date: "Tue, Sep 22",
          time: "7:05 pm",
          logo: "mets.svg",
        },
        {
          date: "Wed, Sep 23",
          time: "7:05 pm",
          logo: "mets.svg",
        },
        {
          date: "Thu, Sep 24",
          time: "1:35 pm",
          logo: "mets.svg",
        },
      ],
    },
    {
      title: "c games",
      cards: [
        {
          date: "Mon, Apr 6",
          time: "7:05 pm",
          logo: "mariners.svg",
        },
        {
          date: "Tue, Apr 7",
          time: "7:05 pm",
          logo: "mariners.svg",
        },
        {
          date: "Wed, Apr 8",
          time: "1:35 pm",
          logo: "mariners.svg",
        },
        {
          date: "Tue, Apr 21",
          time: "7:05 pm",
          logo: "pirates.svg",
        },
        {
          date: "Wed, Apr 22",
          time: "7:05 pm",
          logo: "pirates.svg",
        },
        {
          date: "Thu, Apr 23",
          time: "7:05 pm",
          logo: "pirates.svg",
        },
        {
          date: "Mon, May 11",
          time: "7:05 pm",
          logo: "diamondbacks.svg",
        },
        {
          date: "Tue, May 12",
          time: "7:05 pm",
          logo: "diamondbacks.svg",
        },
        {
          date: "Wed, May 13",
          time: "7:05 pm",
          logo: "diamondbacks.svg",
        },
        {
          date: "Mon, Jun 15",
          time: "7:05 pm",
          logo: "twins.svg",
        },
        {
          date: "Tue, Jun 16",
          time: "7:05 pm",
          logo: "twins.svg",
        },
        {
          date: "Tue, Jul 7",
          time: "7:05 pm",
          logo: "angels.svg",
        },
        {
          date: "Wed, Jul 8",
          time: "7:05 pm",
          logo: "angels.svg",
        },
        {
          date: "Thu, Jul 9",
          time: "7:05 pm",
          logo: "angels.svg",
        },
        {
          date: "Mon, Jul 20",
          time: "7:05 pm",
          logo: "white-sox.svg",
        },
        {
          date: "Tue, Jul 21",
          time: "7:05 pm",
          logo: "white-sox.svg",
        },
        {
          date: "Wed, Jul 22",
          time: "7:05 pm",
          logo: "white-sox.svg",
        },
        {
          date: "Mon, Jul 27",
          time: "1:35 pm",
          logo: "mariners.svg",
        },
        {
          date: "Tue, Aug 18",
          time: "7:05 pm",
          logo: "nationals.svg",
        },
         {
          date: "Wed, Aug 19",
          time: "7:05 pm",
          logo: "nationals.svg",
        },
        {
          date: "Thu, Aug 20",
          time: "7:05 pm",
          logo: "nationals.svg",
        },
        {
          date: "Mon, Aug 31",
          time: "7:05 pm",
          logo: "athletics.svg",
        },
        {
          date: "Tue, Sep 1",
          time: "7:05 pm",
          logo: "athletics.svg",
        },
        {
          date: "Wed, Sep 2",
          time: "1:35 pm",
          logo: "athletics.svg",
        },
        {
          date: "Thu, Sep 3",
          time: "7:05 pm",
          logo: "rays.svg",
        },
      ],
    },
  ];
};
